import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { DistributionNotFound } from "../../components/distribution-not-found";
import { FlowPathProvider } from "../../hooks/use-flow-path";
import { useResetDistributionState } from "../../hooks/use-reset-distribution-state";
import { getConfig } from "../../models/voucher-distribution";
import { useTermsAgreementState } from "../../store/use-terms-agreement-state";
import { useVouchersDistributionState } from "../../store/use-vouchers-distribution-state";
import { childPath } from "../../utils/child-path";
import { configName } from "../config/config-name";
import { routes } from "../config/routes";
import { Catalog } from "./catalog";
import { Checkout } from "./checkout";
import { TermsAgreementPage } from "./terms-agreement";
import { ThankYou } from "./thank-you";

export const PurchaseProductsContent = () => {
  useResetDistributionState();
  const { path } = useRouteMatch();
  const { voucherDistribution } = useVouchersDistributionState();
  const acceptedInStore = useTermsAgreementState((s) => Boolean(s.acceptedConfigs[configName]));
  const config = getConfig(voucherDistribution, configName);

  if (!config) {
    return <DistributionNotFound />;
  }

  const rulesAcceptanceRequired = voucherDistribution?.rulesAcceptanceRequired ?? false;
  const isAccepted = acceptedInStore || !rulesAcceptanceRequired;
  const agreementPath = childPath(path, routes.termsAgreement.raw());
  const catalogPath = childPath(path, routes.catalog.raw());

  return (
    <FlowPathProvider value={path}>
      <Switch>
        <Route path={childPath(path, routes.thankYou.raw())} component={ThankYou} exact />
        <Route
          path={agreementPath}
          exact
          render={() => (rulesAcceptanceRequired ? <TermsAgreementPage /> : <Redirect to={catalogPath} />)}
        />
        <Route path={catalogPath} exact render={() => (isAccepted ? <Catalog /> : <Redirect to={agreementPath} />)} />
        <Route
          path={childPath(path, routes.checkout.raw())}
          exact
          render={() => (isAccepted ? <Checkout /> : <Redirect to={agreementPath} />)}
        />
        <Route component={DistributionNotFound} />
      </Switch>
    </FlowPathProvider>
  );
};
